angular.module('leanlaw').directive('llAccountSetup', ['$timeout', function ($timeout) {
  return {
    restrict: "EA",
    require: "ngModel",
    replace: true,
    template: require("./views/accountSetup.html"),
    scope: {
      ngModel: "=",
      accounts: "=",
      qboType: '@',
      qboSubtype: '@'
    },
    link: function ($scope, element, attrs) {
      $scope.exists = function () {
        return $scope.accounts && $scope.accounts.find(a => a.name == $scope.ngModel.name);
      };
    }
  };
}]);